import { retenoEventsApi } from 'api'

export const enum RetenoEvents {
  RESEND_INSTRUCTIONS = 'ResendInstructions',
  SEND_REDIRECTION_LINK = 'SendRedirectionLink',
  SEND_USER_PERSONALIZED_INFO = 'SendUserPersonalizedInfo',
  SEND_PRINTABLE_UPSELL = 'PrintableUpsell',
}

class RetenoLoggerService {
  private uuid: string | null = null

  init(uuid: string) {
    this.uuid = uuid
  }

  log(event: RetenoEvents, fields: Record<string, string>): void {
    if (!this.uuid) {
      return
    }
    retenoEventsApi.sendRetenoEvent(this.uuid, event, fields)
  }

  logUserRedirectionLink({
    link,
    onelink,
  }: {
    link?: string
    onelink?: string
  }): void {
    const fields = {
      ...(link && { link }),
      ...(onelink && { onelink }),
    }
    this.log(RetenoEvents.SEND_REDIRECTION_LINK, fields)
  }

  logUserName({ name }: { name: string }): void {
    const fields = {
      name,
    }

    this.log(RetenoEvents.SEND_USER_PERSONALIZED_INFO, fields)
  }

  logUserPersonalizedInfo({
    gender,
    age,
    archetype,
  }: {
    gender?: string
    age?: string
    archetype?: string
  }): void {
    const fields = {
      ...(gender && { gender }),
      ...(age && { age }),
      ...(archetype && { archetype }),
    }

    if (!Object.keys(fields).length) {
      return
    }

    this.log(RetenoEvents.SEND_USER_PERSONALIZED_INFO, fields)
  }

  logPrintableUpsell({ printableName }: { printableName: string }): void {
    const fields = {
      printable: printableName,
    }

    this.log(RetenoEvents.SEND_PRINTABLE_UPSELL, fields)
  }
}

export const retenoLogger = new RetenoLoggerService()
